/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/kitkatclub/"

const kitkatclub: CommunityData = {
  code: "kitkatclub",
  inviteCode: "kitkatclub",
  name: "KitKatClub",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/kit-030`,
  defaultCurrency: "EUR",
  waitlist: true,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#fffbea",
      hero: {
        desktop: `${S3_PREFIX}web-background.jpg`,
        mobile: `${S3_PREFIX}web-background-mobile.jpg`,
        style: "bg-[#C8C8C8]",
      },
      logo: {
        desktop: `${S3_PREFIX}logo-2026.png`,
        mobile: `${S3_PREFIX}logo-2026.png`,
        style: "w-[158px] h-[158px] object-contain",
      },
      werzLogoColor: "#191818",
      title: "font-['VerdanaBold'] text-[28px] leading-[120%] text-[#cc0100]",
      text: "font-['VerdanaRegular'] text-[16px] leading-[120%] text-[#370d04]",
      button:
        "font-['LTFunkBold'] text-[20px] leading-[100%] uppercase p-4 rounded-[6px] bg-gradient-to-r from-[#495973] to-[#27334A] text-[#f6fca4] cursor-pointer w-fit",
      input: {
        base: "font-['VerdanaRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#370d04]",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['VerdanaRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['VerdanaRegular'] text-[14px] leading-[120%] text-[#8D8D8D]",
      skipButton:
        "font-['VerdanaRegular'] text-[14px] leading-[120%] text-[#8D8D8D] cursor-pointer",
      modal: {
        container: "bg-[#f0ebd5] px-[40px] py-[48px]",
        title: "font-['VerdanaBold'] text-[24px] leading-[120%] text-[#cc0100] text-center",
        text: "font-['VerdanaRegular'] text-[14px] leading-[120%] text-[#8D8D8D] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#370d04] bg-white font-['VerdanaRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
    global: {
      counterColor: "#370d04",
      logo: {
        src: `${S3_PREFIX}logo-2026.png`,
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}logo-2026.png`,
        styles: "w-[158px] h-[158px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#fffbea",
      asideBg: "#fffbea",
      asideStyles: "border-r border-[#a7a7a7]",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['VerdanaRegular']",
      primaryButton:
        "rounded-[6px] px-[18px] py-[18px] !text-[#f6fca4] font-['LTFunkBold'] !text-[20px] text-left uppercase leading-[100%] bg-gradient-to-r from-[#495973] to-[#27334A]",
    },
    navigation: {
      iconsColor: "#370d04",
      sideBarSeparator: "border-r-[1px] border-[#a7a7a7]",
      separator: "border-[#a7a7a7]",
      item: "font-['PermanentMarkerRegular'] text-[16px] text-[#370d04] text-center gap-x-[10px] text-opacity-50 !border-b-0 border-[#a7a7a7] !pl-0 !py-1",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#fffbea] border-4 border-[#000000] !pb-8",
      titles: "text-[#cc0100] font-['VerdanaBold'] text-[26px] text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#444444] font-['VerdanaRegular'] text-[13px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-dashed border-[#BDBDBD]",
        sectionTitle:
          "text-[#cc0100] font-['VerdanaBold'] text-[26px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#f6fca4] border-2 border-[#000000]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col p-4 bg-transparent border-t-2 border-[#000000]",
          title: "text-[#cc0100] font-['VerdanaBold'] text-[16px] text-left leading-[120%]",
          subtitle:
            "text-[#444444] font-['VerdanaRegular'] text-[13px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-dashed border-[#BDBDBD]",
        sectionTitle:
          "text-[#cc0100] font-['VerdanaBold'] text-[26px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#f6fca4] border-2 border-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title: "text-[#cc0100] font-['VerdanaRegular'] text-[14px] text-left leading-[120%]",
          subtitle:
            "text-[#444444] font-['VerdanaRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#444444] font-['VerdanaRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#444444] font-['VerdanaRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#cc0100] font-['VerdanaBold'] text-[22px] text-left leading-[120%]",
        text: "text-[#370d04] font-['VerdanaRegular'] text-[14px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#cc0100] font-['VerdanaBold'] text-[26px] text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/kitkatclub/web-background-non-member.jpg",
      bgMobile: "https://media.werz.at/community-assets/kitkatclub/web-background-non-member.jpg",
      bgColor: "#fffbea",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#fffbea]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border-2 border-[#000000]",
        name: "text-[#ffffff] font-['VerdanaBold'] text-[26px] leading-[31.2px] text-center text-center mt-4 mb-1",
        location: "font-['VerdanaBold'] leading-[19.2px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#370d04] font-['VerdanaRegular'] text-[14px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#370d04",
        button:
          "bg-[#ebebeb] border border-[#444444] rounded-[6px] px-[12px] py-[12px] text-[#000000] font-['VerdanaRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#fffbea] border-2 border-[#000000] text-[#370d04] font-['VerdanaRegular'] text-[14px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#fffbea] border-2 border-[#000000]",
          title: "font-['VerdanaBold'] leading-[19.2px] text-[16px] text-left text-center mb-1",
          text: "text-[#370d04] font-['VerdanaRegular'] text-[14px] leading-[120%] text-center text-center",
          button:
            "bg-[#ebebeb] border border-[#444444] rounded-[6px] px-[12px] py-[12px] text-[#000000] font-['VerdanaRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['VerdanaBold'] leading-[19.2px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#fffbea] border-2 border-[#000000]",
          duration: "text-[#444444] font-['VerdanaRegular'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#370d04] font-['VerdanaBold'] leading-[19.2px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#370d04",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#fffbea] border-2 border-[#000000]",
          name: "text-[#370d04] font-['VerdanaBold'] leading-[19.2px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#000000] border-[#a7a7a7] text-[#ffffff] font-['VerdanaRegular'] text-[14px] uppercase leading-[16.8px] text-center",
          duration: "text-[#444444] font-['VerdanaRegular'] text-[12px] leading-[14.4px] text-left",
          location: "text-[#444444] font-['VerdanaRegular'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#ebebeb] border border-[#444444] rounded-[6px] px-[12px] py-[12px] text-[#000000] font-['VerdanaRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t-2 border-[#000000]",
            name: "text-[#370d04] font-['VerdanaRegular'] leading-[16.8px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#370d04] font-['VerdanaRegular'] leading-[16.8px] text-[14px] text-left",
            link: "text-[#444444] font-['VerdanaRegular'] text-[13px] leading-[15.6px] text-left",
            status: "text-[#370d04] font-['VerdanaRegular'] leading-[120%] text-[14px] text-left",
            button:
              "bg-[#ebebeb] border border-[#444444] rounded-[6px] px-[12px] py-[12px] text-[#000000] font-['VerdanaRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#370d04] font-['VerdanaRegular'] text-[14px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#fffbea] border-2 border-[#000000] text-[#370d04] font-['VerdanaRegular'] text-[14px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['VerdanaBold'] leading-[19.2px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#fffbea] border-2 border-[#000000]",
          name: "text-[#370d04] font-['VerdanaBold'] leading-[19.2px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#370d04",
          created: "text-[#444444] font-['VerdanaRegular'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        seeAllNews:
          "text-[#370d04] font-['VerdanaRegular'] text-[14px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#fffbea] border-2 border-[#000000] text-[#370d04] font-['VerdanaRegular'] text-[14px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['VerdanaBold'] leading-[19.2px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#fffbea] border-2 border-[#000000]",
          coverUrl: "overflow-hidden m-2 border border-[#000000]",
          duration: "text-[#444444] font-['VerdanaRegular'] text-[12px] leading-[14.4px] text-left",
          liveType: "text-[#444444] font-['VerdanaRegular'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#370d04] rounded-full",
          playIconColor: "#370d04",
          start: "text-[#444444] font-['VerdanaRegular'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#370d04] font-['VerdanaBold'] leading-[19.2px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#370d04] font-['VerdanaRegular'] text-[14px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#fffbea] border-2 border-[#000000] text-[#370d04] font-['VerdanaRegular'] text-[14px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['VerdanaBold'] leading-[19.2px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#fffbea] border-2 border-[#000000]",
          name: "text-[#370d04] font-['VerdanaBold'] leading-[19.2px] text-[16px] text-left",
          triangleIconColor: "#370d04",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#000000]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#444444] font-['VerdanaRegular'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#fffbea] border-4 border-[#000000] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-dashed border-[#BDBDBD]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title: "text-[#cc0100] font-['VerdanaBold'] text-[26px] text-left leading-[120%]",
        subtitle:
          "text-[#444444] font-['VerdanaRegular'] text-[13px] text-left leading-[120%] mb-4 mt-2",
        button:
          "rounded-[6px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#f6fca4] font-['LTFunkBold'] !text-[20px] text-left uppercase leading-[100%] bg-gradient-to-r from-[#495973] to-[#27334A]",
        questions: "text-[13px] text-left leading-[120%] text-[#370d04]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-dashed border-[#BDBDBD]",
        header: "text-[#cc0100] font-['VerdanaBold'] text-[22px] text-left leading-[120%]",
        text: "text-[#370d04] font-['VerdanaRegular'] text-[13px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-dashed border-[#BDBDBD]",
        header: "text-[#cc0100] font-['VerdanaBold'] text-[22px] text-left leading-[120%]",
        text: "text-[#370d04] font-['VerdanaRegular'] text-[13px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border-2 border-[#000000] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#cc0100] font-['VerdanaBold'] text-[22px] text-left leading-[120%]",
        text: "text-[#370d04] font-['VerdanaRegular'] text-[13px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#cc0100] font-['VerdanaBold'] text-[22px] text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#fffbea] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ebebeb] border border-[#444444] rounded-[6px] px-[12px] py-[12px] text-[#000000] font-['VerdanaRegular'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#f6fca4] border-b border-dashed border-[#BDBDBD] p-2",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#cc0100] font-['VerdanaRegular'] text-[14px] text-left leading-[120%] mb-1",
          description:
            "text-[#444444] font-['VerdanaRegular'] text-[13px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#444444] font-['VerdanaRegular'] text-[14px] text-left leading-[120%]",
          quantity: "text-[#000000] font-['VerdanaRegular'] text-[14px] text-left leading-[100%]",
          status: "text-[#444444] font-['VerdanaRegular'] text-[14px] text-left leading-[120%]",
          counterContainer:
            "bg-[#ebebeb] border border-[#444444] rounded-[6px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ebebeb] border border-[#444444] rounded-[6px] px-[12px] py-[12px] text-[#000000] font-['VerdanaRegular'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default kitkatclub
